module.exports = __webpack_public_path__ + "img/app-agrotools-play-store-qrcode.33664c8a.svg";